import { render, staticRenderFns } from "./Rankdea.vue?vue&type=template&id=dc9d8018&scoped=true"
import script from "./Rankdea.vue?vue&type=script&lang=js"
export * from "./Rankdea.vue?vue&type=script&lang=js"
import style0 from "./Rankdea.vue?vue&type=style&index=0&id=dc9d8018&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9d8018",
  null
  
)

export default component.exports